import Request from 'model-fns/request';
import Errors from 'model-fns/errors';
import xtend from 'xtend';
import Effects from '../../effects';
import moment from 'moment';
var DATE_FORMAT = 'YYYY-MM-DD';

function VastModel (api) {
    function model () {
        return {
            resolving: [],
            hasFetched: false,
            errors: [],
            data: {
                campaignAssets: [],
                campaignEvents: [],
                campaignCategoryIDs: [],
                startDate: moment().format(DATE_FORMAT),
                endDate: null,
                // endDate: moment().format(DATE_FORMAT),
                actionID: 0,
                typeID: 3,
                name: ''
            },
            messages: []
        };
    }

    model.effects = Effects({
        get: api.vast.getByID,
        edit: api.vast.edit,
        add: api.vast.add
    });

    model.update = xtend(Request.update, Errors.update, {
        get: function (state, ev) {
            return xtend(state, { data: ev, hasFetched: true });
        },

        shiftMessage: function (state, ev) {
            return xtend(state, {
                messages: state.messages.slice(1)
            });
        },

        edit: function (state, ev) {
            return xtend(state, {
                messages: state.messages.concat([{
                    message: 'Campaign saved'
                }]),
                data: ev
            });
        },

        add: function (state, ev) {
            return xtend(state, {
                messages: state.messages.concat([{
                    message: 'New campaign created'
                }]),
                data: ev
            });
        }
    });

    return model;
}

export default VastModel;
